<template>
  <v-container>
    <v-row v-if="isInProgress">
      <v-col>
        <v-row justify="center" align="center"
          ><v-progress-circular
            :rotate="180"
            :size="100"
            :width="15"
            :value="progressValue"
            color="pink"
          >
            {{ progressValue }}%
          </v-progress-circular>
        </v-row>
        <v-row justify="center" align="center"> {{ progressMessage }}</v-row>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col>
        <table border="1">
          <thead class="v-data-table-header">
            <tr>
              <th class="text-left" rowspan="2">Date</th>
              <th
                v-for="paxRange in paxRanges"
                :key="paxRange.id"
                :colspan="roomTypes.length"
              >
                Pax From:{{ paxRange.paxFrom }} - Pax to:{{ paxRange.paxTo }}
              </th>
            </tr>
            <tr>
              <template v-for="paxRange in paxRanges">
                <th
                  :id="`${roomType}_${paxRange.id}`"
                  v-for="roomType in roomTypes"
                >
                  {{ roomType }}
                </th>
              </template>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in items" :id="item.id">
              <td>{{ item.date | formatDate }}</td>
              <template v-for="paxPrice in item.paxPricing">
                <td v-for="charge in paxPrice.charges">
                  {{ Number(charge.total).toFixed(2) }}
                </td>
              </template>
            </tr>
          </tbody>
        </table>
        <div v-if="debug">
          <code>{{ show }}</code>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ITINERARY_RECALCULATE_MUTATION } from "../../../../../constants/graphql";
import { removeGQLTypename, sortByDateField } from "../../../../../helpers";

import {
  getItineraryInput,
  getPaxPricing,
  getServicesPricing,
} from "./helpers";
export default {
  name: "increments-group-table",
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => null,
    },
    templateItems: {
      type: Array,
      default: () => [],
    },
    templateId: {
      type: String,
      default: () => "",
    },
    department: {
      type: String,
      default: () => "FIT",
    },
    destination: {
      type: String,
      default: () => "",
    },
    forAdults: {
      type: Boolean,
      default: () => false,
    },
    forChildren: {
      type: Boolean,
      default: () => false,
    },
    forInfants: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      debug: false,
      isInProgress: false,
      progressMessage: "Recalculating Itineraries",
      progressValue: 0,
      itisData: {},
    };
  },

  computed: {
    paxRanges() {
      return this.items.length > 0
        ? this.items[0].paxPricing.map((item) => ({
            id: `${item.minPax}_${item.maxPax}`,
            paxFrom: item.minPax,
            paxTo: item.maxPax,
          }))
        : [];
      // return this.value
      //   ? this.value.increments[0].adjustments.edges.map((a) => ({
      //       id: `${a.node.paxFrom}_${a.node.paxTo}`,
      //       paxFrom: a.node.paxFrom,
      //       paxTo: a.node.paxTo,
      //     }))
      //   : [];
    },
    departureDates() {
      return this.value ? this.value.increments.map((i) => i.date) : [];
    },
    items() {
      // console.log(
      //   "items condition",
      //   Object.keys(this.itisData).length,
      //   this.departureDates.length,
      //   this.value,
      //   Object.keys(this.itisData).length >= this.departureDates.length &&
      //     this.value
      // );
      let paxField = "adults";
      if (this.forChildren) {
        paxField = "children";
      } else if (this.forInfants) {
        paxField = "infants";
      }
      return Object.keys(this.itisData).length == this.departureDates.length &&
        this.value
        ? this.value.increments
            .slice()
            .sort(sortByDateField("date"))
            .map((inc) => {
              const date = inc.date;
              const itiData = this.itisData[date];
              const servicesPricing = getServicesPricing(itiData, paxField);
              //console.log(servicesPricing);
              const paxPricing = getPaxPricing({
                adjustments: inc.adjustments.edges.map(removeGQLTypename),
                servicesPricing,
              });
              return {
                date,
                id: inc.id,
                paxPricing,
              };
            })
        : [];
    },
    roomTypes() {
      return this.items.length > 0
        ? this.items[0].paxPricing[0].charges.map((c) => c.name)
        : [];
    },
  },

  watch: {
    show(newVal) {
      //   console.log("show changed", newVal);
      if (newVal) {
        this.itisData = {};
        this.getItiData();
      }
    },
  },
  methods: {
    async getItiData() {
      const agentId = this.$store.getters.agentId;
      const itisData = {};

      const itiInputs = this.value.increments.reduce((inputs, inc) => {
        const adults = this.forAdults ? inc.maxPax.toString() : "0";
        const children = this.forChildren ? inc.maxPax.toString() : "0";
        const infants = this.forInfants ? inc.maxPax.toString() : "0";
        inputs[inc.date] = getItineraryInput({
          agentId,
          destinationId: this.destination,
          department: this.department,
          templateItems: this.templateItems,
          date: inc.date,
          adults,
          children,
          infants,
          duration: 10,
        });
        return inputs;
      }, {});
      this.isInProgress = true;
      let i = 0;
      const size = this.value.increments.length;
      for (const date of Object.keys(itiInputs)) {
        const input = itiInputs[date];
        const result = await this.$apollo.mutate({
          mutation: ITINERARY_RECALCULATE_MUTATION,
          variables: input,
        });
        if (result) {
          i++;
          this.progressValue = Math.round((i / size) * 100);
          itisData[date] = {
            ...result.data.recalculateItinerary,
          };
        }
      }
      this.isInProgress = false;
      this.itisData = { ...itisData };
    },
  },
  mounted() {
    this.getItiData();
  },
};
</script>

<style scoped>
table,
td,
th {
  border: 1px solid #ddd;
}

table {
  border-collapse: collapse;
  display: table;
  width: 100%;
  table-layout: fixed;
}

tr td:hover {
  background-color: #f5f5f5;
}

th,
td {
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/gt/templates/builder/increments/IncrementsGroupDialogTable.vue